import { useMutation, useQueryClient } from '@tanstack/react-query';

import collectiveApi from 'modules/common/collectiveApi';

const useDeleteMemberDocument = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (documentId: string) => collectiveApi.delete(`/documents/member-documents/${documentId}/`),
        onSuccess: () => {
            // Invalidate document queries
            queryClient.invalidateQueries({ queryKey: ['memberDocuments'] });
            queryClient.invalidateQueries({ queryKey: ['accountingOnboardingProgress'] });
        },
        onError: (error) => {
            console.error('Failed to delete member document:', error);
        },
    });
};

export default useDeleteMemberDocument;
